export default __webpack_public_path__ + "static/media/cashfast.42f587e9.ico";